// RecommendedProducts.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api/axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const RecommendedProducts = ({ currentProductId, category }) => {
  const [recommended, setRecommended] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchRecommended = async () => {
      try {
        setLoading(true);
        // Intentar obtener productos por categoría
        let { data } = await API.get(`/products/category/${encodeURIComponent(category)}`);
        // Si no hay resultados, se intenta con búsqueda de texto
        if (!data || data.length === 0) {
          const response = await API.get(`/products/search?query=${encodeURIComponent(category)}`);
          data = response.data;
        }
        // Excluir el producto actual
        const filtered = data.filter((p) => p._id !== currentProductId);
        setRecommended(filtered);
        setLoading(false);
      } catch (error) {
        console.error("Error obteniendo productos recomendados:", error);
        setLoading(false);
      }
    };

    if (category) fetchRecommended();
  }, [category, currentProductId]);

  // Configuración dinámica del carrusel:
  const slidesToShow = recommended.length < 3 ? recommended.length : 3;
  const sliderSettings = {
    dots: true,
    infinite: recommended.length > slidesToShow,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: recommended.length < 2 ? recommended.length : 2 },
      },
      {
        breakpoint: 640,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  if (loading) {
    return <p className="text-center text-gray-600">Cargando recomendados...</p>;
  }

  if (recommended.length === 0) {
    return null;
  }

  return (
    <div className="mt-10 mx-auto max-w-7xl px-4">
      <h2 className="text-2xl font-bold mb-4">Te podría interesar</h2>
      <Slider {...sliderSettings} className="pb-6">
        {recommended.map((item) => {
          const itemFinalPrice =
            item.discount > 0
              ? (item.price * (1 - item.discount / 100)).toFixed(2)
              : item.price.toFixed(2);
          return (
            <div key={item._id} className="px-2">
              <div
                onClick={() => navigate(`/product/${item._id}`)}
                className="relative bg-white border rounded-lg p-4 text-center cursor-pointer hover:shadow-lg transition-transform transform hover:scale-105 h-full flex flex-col justify-between"
              >
                {item.discount > 0 && (
                  <span className="absolute top-2 left-2 bg-red-500 text-white text-xs font-bold px-2 py-0.5 rounded">
                    -{item.discount}%
                  </span>
                )}
                <img
                  src={`${process.env.REACT_APP_BACKEND_URL}/uploads/productImage/${item.image}`}
                  alt={item.title}
                  className="w-full h-40 object-cover rounded-md mb-2"
                />
                <h3 className="text-lg font-semibold">{item.title}</h3>
                {item.discount > 0 ? (
                  <p className="text-gray-700">
                    <span className="line-through text-red-500">${item.price}</span>{" "}
                    <span className="font-bold">${itemFinalPrice}</span>
                  </p>
                ) : (
                  <p className="text-blue-600 font-bold">${itemFinalPrice}</p>
                )}
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default RecommendedProducts;
